<script>
import Common from '../../../common/Common.vue'
import Endpoints from '../../../common/Endpoints.vue'
import Request from '../../../common/Request.vue'
import Services from '../../../common/Services.vue'
import { applySessionScope } from '../../../utils/scope'

export default {
    init: async payload => {
        payload.isSuperAdminMaster = await Common.isSuperAdminMaster(payload)
        payload.initTable()

        const role = await Common.getSubtype(payload)
        payload.role = role

        if (role === 'SUPER_ADMIN_MASTER') {
            payload.accounts = await Services.getAccounts(payload)
            payload.clients = await Services.getClients(payload)
        } else if (role === 'ADMIN' || role === 'MANAGER') {
            payload.clients = await Services.getClients(payload)
            payload.filters.account = Common.getAccountId(payload)
        } else if (role === 'OPERATOR') {
            payload.filters.account = Common.getAccountId(payload)
            payload.sites = await Services.getSites(payload)
        }

        if (!payload.isSuperAdminMaster) {
            payload.columns.splice(3, 1)
        }

        payload.brands = await Services.getEquipmentBrands(payload)
        payload.equipmentTypes = await Services.getEquipmentTypes(payload)
    },
    methods: {
        filter: function () {
            if (!applySessionScope(this, this.filters)) return

            this.isLoading = true
            this.items = []
            this.enrichFiltersWithPagination()
            Request.do(
                this,
                'POST',
                Request.getDefaultHeader(this),
                this.filters,
                `${Endpoints.equipments.filter}`,
                response => {
                    this.applyServerPage(response)
                    this.isLoading = false
                },
                () => {
                    this.isLoading = false
                },
            )
        },
        selectItem(params) {
            const data = params && params?.row ? JSON.parse(JSON.stringify(params.row)) : { ...this.equipmentObj }

            delete data.vgt_id
            delete data.originalIndex

            data.account = data?.account?._id || ''
            data.client = data?.client?._id || ''
            data.site = data?.site?._id || ''

            this.data = data

            this.$bvModal.show('registerModal')
        },

        async initTable() {
            this.columns = [
                {
                    label: this.$t('str.table.equipment.column.code'),
                    field: 'code',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.equipment.column.type'),
                    field: 'type',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.equipment.column.brand'),
                    field: 'brand',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                // {
                //     label: this.$t('str.table.equipment.column.guard'),
                //     field: 'user.fullName',
                //     width: '10%',
                //     thClass: 'text-nowrap',
                //     tdClass: 'text-nowrap',
                //     sortable: true,
                //     filterable: true,
                // },
                {
                    label: this.$t('str.table.equipment.column.account'),
                    field: 'account.name',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.equipment.column.client'),
                    field: 'client.name',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.equipment.column.site'),
                    field: 'site.name',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.equipment.column.creat.at'),
                    field: 'createDate',
                    width: '10%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.equipment.column.status'),
                    field: 'status',
                    width: '10%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
            ]
            this.paginationOptions = this.buildServerPaginationOptions(this)
        },
        changeAccount: async function () {
            const account = this.filters.account

            this.sites = []
            this.filters.client = ''
            this.filters.site = ''

            this.filterFromFirstPage()

            this.clients = await Services.getClientsByAccount(this, account)
        },
        changeClient: async function () {
            const client = this.filters.client

            if (client === '') {
                this.filters.site = ''
            }

            this.filterFromFirstPage()

            this.sites = await Services.getSitesByClient(this, client)
        },
        changeSite: function () {
            this.filterFromFirstPage()
        },
        formatDate: Common.formatDateAndTime,
    },
}
</script>
